import { render } from "./Cur-order.vue?vue&type=template&id=63c35bb6&scoped=true"
import script from "./Cur-order.vue?vue&type=script&lang=js"
export * from "./Cur-order.vue?vue&type=script&lang=js"

import "./Cur-order.vue?vue&type=style&index=0&id=63c35bb6&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c35bb6"]])

export default __exports__